import { render, staticRenderFns } from "./MailServiceSetting.vue?vue&type=template&id=364e3607&scoped=true"
import script from "./MailServiceSetting.vue?vue&type=script&lang=js"
export * from "./MailServiceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e3607",
  null
  
)

export default component.exports